<div class="card">
  <app-header
    titulo="Contratos Pendentes de Cancelamento"
    descricao="Cancelados no PIMS mas não cancelados no ERP"
  ></app-header>

  <app-contratos [habilitaCancelamento]="true" [habilitaIntegracao]="false" statusContrato="CP" [habilitaData]="true"></app-contratos>

</div>
